import { render, staticRenderFns } from "./hotSpotPic.vue?vue&type=template&id=36a232be&scoped=true"
import script from "./hotSpotPic.vue?vue&type=script&lang=js"
export * from "./hotSpotPic.vue?vue&type=script&lang=js"
import style0 from "./hotSpotPic.vue?vue&type=style&index=0&id=36a232be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a232be",
  null
  
)

export default component.exports